import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const CrossRoad_12BBlue_12DRed = props => <CrossRoad coords="2134.000000, 432.000000" color={tracksColors.blue}/>;

export default CrossRoad_12BBlue_12DRed;
